import { format } from 'date-fns';

export default (date: Date): string => format(date, 'dd.MM.yy HH:mm');
